/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Home_Seats_NoteInputs */



/**
* | output |
* | --- |
* | "active across your customers, guests not counted" |
*
* @param {Partner_Home_Seats_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_home_seats_note = /** @type {((inputs?: Partner_Home_Seats_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Home_Seats_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("aktiv bei Ihren Kunden, ohne Gäste")
	return /** @type {LocalizedString} */ ("active across your customers, guests not counted")
});